import { z } from 'zod';

export const InboundChargeTypeSchema = z.enum([
  'FREIGHT',
  'IPI_NON_RECOVERABLE',
  'INSURANCE',
  'OTHER_ACCESSORY',
]);
export type InboundChargeType = z.infer<typeof InboundChargeTypeSchema>;

export const InboundChargePolicyValueSchema = z.enum(['CAPITALIZE', 'EXPENSE']);
export type InboundChargePolicyValue = z.infer<typeof InboundChargePolicyValueSchema>;

export const InboundChargePolicyItemSchema = z.object({
  chargeType: InboundChargeTypeSchema,
  policy: InboundChargePolicyValueSchema,
  isDefault: z.boolean(),
});
export type InboundChargePolicyItem = z.infer<typeof InboundChargePolicyItemSchema>;

export const GetInboundChargePolicyResponseSchema = z.object({
  items: z.array(InboundChargePolicyItemSchema).length(4),
});
export type GetInboundChargePolicyResponse = z.infer<typeof GetInboundChargePolicyResponseSchema>;

export const UpsertInboundChargePolicyBodySchema = z.object({
  items: z
    .array(
      z.object({
        chargeType: InboundChargeTypeSchema,
        policy: InboundChargePolicyValueSchema,
      }),
    )
    .length(4)
    .refine((items) => new Set(items.map((item) => item.chargeType)).size === 4, {
      message: 'Each charge type must appear exactly once',
    }),
});
export type UpsertInboundChargePolicyBody = z.infer<typeof UpsertInboundChargePolicyBodySchema>;
